import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import MarqueeRibbon from "./MarqueeRibbon";
import ProblemSection from "./ProblemSection";
import PillarsSection from "./PillarsSection";
import ResultsSection from "./ResultsSection";
import FaqSection from "./FaqSection";
import LetsChat from "./LetsChat";
import FinalCTA from "./FinalCTA";
import SectionGate from "./SectionGate";
import TypeformModal from "./TypeformModal";
import AmbientAudio from "./AmbientAudio";

const LandingPage = () => {
    return (
        <div data-testid="landing-page" className="bg-noise min-h-screen bg-void text-white">
            <Navbar />
            <Hero />
            <MarqueeRibbon />
            <SectionGate testId="gate-after-marquee" label="The walk continues — follow the pillars" />
            <ProblemSection />
            <PillarsSection />
            <ResultsSection />
            <FaqSection />
            <LetsChat />
            <SectionGate testId="gate-before-cta" label="Final pillar reached" />
            <FinalCTA />
            <TypeformModal />
            <AmbientAudio />
        </div>
    );
};

export default LandingPage;
